import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import ProjectForm from "./ProjectForm";
import * as Yup from "yup";
import * as actions from './store/projectActions';
import History from "../../../../History";
import { hasPermission, parseURL } from "../../../sc-utilities";
import * as groupActions from "../../../sc-group/Group/store/groupActions";


const ProjectCreate = props => {
    const { activeCustomerID, translations, permissions, createProject, fetchGroups } = props;
    const searchParams = parseURL(window.location.href);

    const [groups, setGroups] = useState(null);

    useEffect(() => {
        const getGroups = async () => {
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomerID });
            if (resultGroups) {
                let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
                if (hasPermission(permissions, 'access_all_projects_on_customer')) {
                    groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
                }
                setGroups(groupsToSet);
            }
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
    }, [fetchGroups, activeCustomerID, permissions]);

    const handleSubmit = async data => {
        let formData = { ...data };
        if (formData.GroupID === 'n/a') {
            formData.GroupID = null;
        }

        let result = await createProject({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        FancyName: "",
        GroupID: groups?.map(group => group?.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            FancyName: Yup.string().required("Required")
        },
        FormTitle: translations["create_project"] || "Create project",
        ButtonSubmit: hasPermission(permissions, 'project_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        <ProjectForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            translations={translations}
            groups={groups}
        />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createProject: data => dispatch(actions.createProject(data)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectCreate);
